/**
 * This file is auto generated via npm run generate.resolved-tailwind
 */

export type Color =
  | 'purple'
  | 'dark-purple'
  | 'light-purple'
  | 'lighter-purple'
  | 'white'
  | 'dark-white'
  | 'lighter-gray'
  | 'light-gray'
  | 'medium-gray'
  | 'dark-gray'
  | 'red'
  | 'green'
  | 'light-outline-purple'
  | 'light-outline-gray'
  | 'outline-gray'
  | 'orange'
  | 'red-orange'
  | 'light-blue'
  | 'medium-blue'
  | 'light-beige'
  | 'beige'
  | 'yellow'
  | 'ui-yellow'
  | 'transparent'
  | 'black';

export const ALL_COLORS: Color[] = [
  'purple',
  'dark-purple',
  'light-purple',
  'lighter-purple',
  'white',
  'dark-white',
  'lighter-gray',
  'light-gray',
  'medium-gray',
  'dark-gray',
  'red',
  'green',
  'light-outline-purple',
  'light-outline-gray',
  'outline-gray',
  'orange',
  'red-orange',
  'light-blue',
  'medium-blue',
  'light-beige',
  'beige',
  'yellow',
  'ui-yellow',
  'transparent',
  'black',
];

export default {
  colors: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  fontFamily: {
    sans: ['Lato', 'sans-serif'],
    body: ['Lato', 'sans-serif'],
    serif: ['adobe-caslon-pro', 'Adobe Caslon Pro', 'EB Garamond', 'serif'],
  },
  screens: {
    'sm': '640px',
    'md': '768px',
    'lg': '1024px',
    'xl': '1200px',
    '2xl': '1536px',
    'xxs': '0px',
    'xs': '360px',
    'xxl': '1366px',
    '3xl': '1600px',
    'md-down': { max: '1023px' },
    'sm-down': { max: '767px' },
  },
  spacing: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
  },
  animation: {
    none: 'none',
    spin: 'spin 1s linear infinite',
    ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
    pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    bounce: 'bounce 1s infinite',
  },
  backdropBlur: {
    '0': '0',
    'none': '0',
    'sm': '4px',
    'DEFAULT': '8px',
    'md': '12px',
    'lg': '16px',
    'xl': '24px',
    '2xl': '40px',
    '3xl': '64px',
  },
  backdropBrightness: {
    '0': '0',
    '50': '.5',
    '75': '.75',
    '90': '.9',
    '95': '.95',
    '100': '1',
    '105': '1.05',
    '110': '1.1',
    '125': '1.25',
    '150': '1.5',
    '200': '2',
  },
  backdropContrast: {
    '0': '0',
    '50': '.5',
    '75': '.75',
    '100': '1',
    '125': '1.25',
    '150': '1.5',
    '200': '2',
  },
  backdropGrayscale: { '0': '0', 'DEFAULT': '100%' },
  backdropHueRotate: {
    '0': '0deg',
    '15': '15deg',
    '30': '30deg',
    '60': '60deg',
    '90': '90deg',
    '180': '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-60': '-60deg',
    '-30': '-30deg',
    '-15': '-15deg',
  },
  backdropInvert: { '0': '0', 'DEFAULT': '100%' },
  backdropOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  backdropSaturate: {
    '0': '0',
    '50': '.5',
    '100': '1',
    '150': '1.5',
    '200': '2',
  },
  backdropSepia: { '0': '0', 'DEFAULT': '100%' },
  backgroundColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  backgroundImage: {
    'none': 'none',
    'gradient-to-t': 'linear-gradient(to top, var(--tw-gradient-stops))',
    'gradient-to-tr': 'linear-gradient(to top right, var(--tw-gradient-stops))',
    'gradient-to-r': 'linear-gradient(to right, var(--tw-gradient-stops))',
    'gradient-to-br':
      'linear-gradient(to bottom right, var(--tw-gradient-stops))',
    'gradient-to-b': 'linear-gradient(to bottom, var(--tw-gradient-stops))',
    'gradient-to-bl':
      'linear-gradient(to bottom left, var(--tw-gradient-stops))',
    'gradient-to-l': 'linear-gradient(to left, var(--tw-gradient-stops))',
    'gradient-to-tl': 'linear-gradient(to top left, var(--tw-gradient-stops))',
  },
  backgroundOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  backgroundPosition: {
    'bottom': 'bottom',
    'center': 'center',
    'left': 'left',
    'left-bottom': 'left bottom',
    'left-top': 'left top',
    'right': 'right',
    'right-bottom': 'right bottom',
    'right-top': 'right top',
    'top': 'top',
  },
  backgroundSize: { auto: 'auto', cover: 'cover', contain: 'contain' },
  blur: {
    '0': '0',
    'none': '0',
    'sm': '4px',
    'DEFAULT': '8px',
    'md': '12px',
    'lg': '16px',
    'xl': '24px',
    '2xl': '40px',
    '3xl': '64px',
  },
  brightness: {
    '0': '0',
    '50': '.5',
    '75': '.75',
    '90': '.9',
    '95': '.95',
    '100': '1',
    '105': '1.05',
    '110': '1.1',
    '125': '1.25',
    '150': '1.5',
    '200': '2',
  },
  borderColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
    'DEFAULT': 'currentColor',
  },
  borderOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  borderRadius: {
    'none': '0px',
    'sm': '0.125rem',
    'DEFAULT': '0.25rem',
    'md': '0.375rem',
    'lg': '0.5rem',
    'xl': '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    'full': '9999px',
  },
  borderWidth: {
    '0': '0px',
    '2': '2px',
    '3': '3px',
    '4': '4px',
    '8': '8px',
    'DEFAULT': '1px',
  },
  boxShadow: {
    'sm': '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    'DEFAULT':
      '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    'md': '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    'lg': '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    'xl': '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    'inner': 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    'none': 'none',
    'light-purple-outline': '0 0 20px 0 rgba(107, 31, 153, 0.6)',
    'large-subtle-black': '0 0 36px 0px rgba(0,0,0,0.16)',
    'large-subtle-grey': '0px 0px 36px rgba(35, 35, 35, 0.22)',
  },
  caretColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  contrast: {
    '0': '0',
    '50': '.5',
    '75': '.75',
    '100': '1',
    '125': '1.25',
    '150': '1.5',
    '200': '2',
  },
  container: {},
  content: { none: 'none' },
  cursor: {
    'auto': 'auto',
    'default': 'default',
    'pointer': 'pointer',
    'wait': 'wait',
    'text': 'text',
    'move': 'move',
    'help': 'help',
    'not-allowed': 'not-allowed',
  },
  divideColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
    'DEFAULT': 'currentColor',
  },
  divideOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  divideWidth: {
    '0': '0px',
    '2': '2px',
    '3': '3px',
    '4': '4px',
    '8': '8px',
    'DEFAULT': '1px',
  },
  dropShadow: {
    'sm': '0 1px 1px rgba(0,0,0,0.05)',
    'DEFAULT': [
      '0 1px 2px rgba(0, 0, 0, 0.1)',
      '0 1px 1px rgba(0, 0, 0, 0.06)',
    ],
    'md': ['0 4px 3px rgba(0, 0, 0, 0.07)', '0 2px 2px rgba(0, 0, 0, 0.06)'],
    'lg': ['0 10px 8px rgba(0, 0, 0, 0.04)', '0 4px 3px rgba(0, 0, 0, 0.1)'],
    'xl': ['0 20px 13px rgba(0, 0, 0, 0.03)', '0 8px 5px rgba(0, 0, 0, 0.08)'],
    '2xl': '0 25px 25px rgba(0, 0, 0, 0.15)',
    'none': '0 0 #0000',
  },
  fill: { current: 'currentColor' },
  grayscale: { '0': '0', 'DEFAULT': '100%' },
  hueRotate: {
    '0': '0deg',
    '15': '15deg',
    '30': '30deg',
    '60': '60deg',
    '90': '90deg',
    '180': '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-60': '-60deg',
    '-30': '-30deg',
    '-15': '-15deg',
  },
  invert: { '0': '0', 'DEFAULT': '100%' },
  flex: {
    '1': '1 1 0%',
    'auto': '1 1 auto',
    'initial': '0 1 auto',
    'none': 'none',
    '1/3': '1 1 33%',
  },
  flexGrow: { '0': '0', 'DEFAULT': '1' },
  flexShrink: { '0': '0', 'DEFAULT': '1' },
  fontSize: {
    'xs': '0.875rem',
    'sm': '0.9375rem',
    'base': '1rem',
    'lg': '1.125rem',
    'xl': '1.25rem',
    '2xl': '1.375rem',
    '3xl': '1.5rem',
    '4xl': '1.625rem',
    '5xl': '1.75rem',
    '6xl': '1.875rem',
    '7xl': '2.5rem',
    '8xl': '2.8125rem',
    '9xl': ['8rem', { lineHeight: '1' }],
    '4xs': '0.65rem',
    '3xs': '0.75rem',
    '2xs': '0.8125rem',
  },
  fontWeight: {
    thin: '100',
    extralight: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  gap: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
  },
  gradientColorStops: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  gridAutoColumns: {
    auto: 'auto',
    min: 'min-content',
    max: 'max-content',
    fr: 'minmax(0, 1fr)',
  },
  gridAutoRows: {
    auto: 'auto',
    min: 'min-content',
    max: 'max-content',
    fr: 'minmax(0, 1fr)',
  },
  gridColumn: {
    'auto': 'auto',
    'span-1': 'span 1 / span 1',
    'span-2': 'span 2 / span 2',
    'span-3': 'span 3 / span 3',
    'span-4': 'span 4 / span 4',
    'span-5': 'span 5 / span 5',
    'span-6': 'span 6 / span 6',
    'span-7': 'span 7 / span 7',
    'span-8': 'span 8 / span 8',
    'span-9': 'span 9 / span 9',
    'span-10': 'span 10 / span 10',
    'span-11': 'span 11 / span 11',
    'span-12': 'span 12 / span 12',
    'span-full': '1 / -1',
  },
  gridColumnEnd: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '13',
    'auto': 'auto',
  },
  gridColumnStart: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '13',
    'auto': 'auto',
  },
  gridRow: {
    'auto': 'auto',
    'span-1': 'span 1 / span 1',
    'span-2': 'span 2 / span 2',
    'span-3': 'span 3 / span 3',
    'span-4': 'span 4 / span 4',
    'span-5': 'span 5 / span 5',
    'span-6': 'span 6 / span 6',
    'span-full': '1 / -1',
  },
  gridRowStart: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    'auto': 'auto',
  },
  gridRowEnd: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    'auto': 'auto',
  },
  gridTemplateColumns: {
    '1': 'repeat(1, minmax(0, 1fr))',
    '2': 'repeat(2, minmax(0, 1fr))',
    '3': 'repeat(3, minmax(0, 1fr))',
    '4': 'repeat(4, minmax(0, 1fr))',
    '5': 'repeat(5, minmax(0, 1fr))',
    '6': 'repeat(6, minmax(0, 1fr))',
    '7': 'repeat(7, minmax(0, 1fr))',
    '8': 'repeat(8, minmax(0, 1fr))',
    '9': 'repeat(9, minmax(0, 1fr))',
    '10': 'repeat(10, minmax(0, 1fr))',
    '11': 'repeat(11, minmax(0, 1fr))',
    '12': 'repeat(12, minmax(0, 1fr))',
    'none': 'none',
  },
  gridTemplateRows: {
    '1': 'repeat(1, minmax(0, 1fr))',
    '2': 'repeat(2, minmax(0, 1fr))',
    '3': 'repeat(3, minmax(0, 1fr))',
    '4': 'repeat(4, minmax(0, 1fr))',
    '5': 'repeat(5, minmax(0, 1fr))',
    '6': 'repeat(6, minmax(0, 1fr))',
    'none': 'none',
  },
  height: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    '205': '205px',
    'auto': 'auto',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    'full': '100%',
    'screen': '100vh',
  },
  inset: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'auto': 'auto',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.5rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-20': '-5rem',
    '-22': '-5.5rem',
    '-24': '-6rem',
    '-25': '-6.25rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-34': '-8.5rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-144': '-36rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '-7/10': '-70%',
    '-55/100': '-55%',
    '-1/2': '-50%',
    '-45/100': '-45%',
    '-2/5': '-40%',
    '-3/10': '-30%',
    '--18': '4.5rem',
    '--16': '4rem',
    '--2px': '2px',
    '-3px': '-3px',
    '-4px': '-4px',
    '-6px': '-6px',
    '-8px': '-8px',
    '-18px': '-18px',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    'full': '100%',
    '-1/3': '-33.333333%',
    '-2/3': '-66.666667%',
    '-1/4': '-25%',
    '-2/4': '-50%',
    '-3/4': '-75%',
    '-full': '-100%',
    '-h-screen': '-100vh',
    '-w-screen': '-100vw',
    'h-screen': '100vh',
    'w-screen': '100vw',
  },
  keyframes: {
    spin: { to: { transform: 'rotate(360deg)' } },
    ping: { '75%, 100%': { transform: 'scale(2)', opacity: '0' } },
    pulse: { '50%': { opacity: '.5' } },
    bounce: {
      '0%, 100%': {
        transform: 'translateY(-25%)',
        animationTimingFunction: 'cubic-bezier(0.8,0,1,1)',
      },
      '50%': {
        transform: 'none',
        animationTimingFunction: 'cubic-bezier(0,0,0.2,1)',
      },
    },
  },
  letterSpacing: {
    'tighter': '-0.046875rem',
    'tight': '-0.0425rem',
    'normal': '0em',
    'wide': '0.0625rem',
    'wider': '0.125rem',
    'widest': '0.1em',
    'very-tight': '-0.0625rem',
    'snug': '-0.03125rem',
  },
  lineHeight: {
    '3': '.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    'none': '1',
    'tight': '1.25',
    'snug': '1.4',
    'normal': '1.5',
    'relaxed': '1.625',
    'loose': '2',
    'header-tight': '1.1',
    'header-snug': '1.15',
    'header-normal': '1.2',
    'header-relaxed': '1.4',
    'header-loose': '1.5',
  },
  listStyleType: { none: 'none', disc: 'disc', decimal: 'decimal' },
  margin: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'auto': 'auto',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-20': '-5rem',
    '-22': '-5.5rem',
    '-24': '-6rem',
    '-25': '-6.25rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-34': '-8.5rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-144': '-36rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '-7/10': '-70%',
    '-55/100': '-55%',
    '-1/2': '-50%',
    '-45/100': '-45%',
    '-2/5': '-40%',
    '-3/10': '-30%',
    '--18': '4.5rem',
    '--16': '4rem',
    '--2px': '2px',
    '-3px': '-3px',
    '-4px': '-4px',
    '-6px': '-6px',
    '-8px': '-8px',
    '-18px': '-18px',
    'sticky-right': 'calc(50% - 50vw)',
    'flush-header': '-112px',
  },
  maxHeight: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    'full': '100%',
    'screen': '100vh',
    '2/3': '66%',
  },
  maxWidth: {
    '0': '0rem',
    'none': 'none',
    'xs': '20rem',
    'sm': '24rem',
    'md': '28rem',
    'lg': '32rem',
    'xl': '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    'full': '100%',
    'min': 'min-content',
    'max': 'max-content',
    'prose': '65ch',
    'screen-sm': '640px',
    'screen-md': '768px',
    'screen-lg': '1024px',
    'screen-xl': '1200px',
    'screen-2xl': '1536px',
    'screen-xxs': '0px',
    'screen-xs': '360px',
    'screen-xxl': '1366px',
    'screen-3xl': '1600px',
    '1/2': '50%',
    '2/3': '66%',
  },
  minHeight: { '0': '0px', 'full': '100%', 'screen': '100vh' },
  minWidth: {
    '0': '0px',
    'full': '100%',
    'min': 'min-content',
    'max': 'max-content',
    '1/2': '50%',
    '2/3': '66%',
  },
  objectPosition: {
    'bottom': 'bottom',
    'center': 'center',
    'left': 'left',
    'left-bottom': 'left bottom',
    'left-top': 'left top',
    'right': 'right',
    'right-bottom': 'right bottom',
    'right-top': 'right top',
    'top': 'top',
  },
  opacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  order: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    'first': '-9999',
    'last': '9999',
    'none': '0',
  },
  outline: {
    none: ['2px solid transparent', '2px'],
    white: ['2px dotted white', '2px'],
    black: ['2px dotted black', '2px'],
  },
  padding: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
  },
  placeholderColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  placeholderOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  ringColor: {
    'DEFAULT': '#3b82f6',
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  ringOffsetColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  ringOffsetWidth: {
    '0': '0px',
    '1': '1px',
    '2': '2px',
    '4': '4px',
    '8': '8px',
  },
  ringOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
    'DEFAULT': '0.5',
  },
  ringWidth: {
    '0': '0px',
    '1': '1px',
    '2': '2px',
    '4': '4px',
    '8': '8px',
    'DEFAULT': '3px',
  },
  rotate: {
    '0': '0deg',
    '1': '1deg',
    '2': '2deg',
    '3': '3deg',
    '6': '6deg',
    '12': '12deg',
    '45': '45deg',
    '90': '90deg',
    '180': '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-45': '-45deg',
    '-12': '-12deg',
    '-6': '-6deg',
    '-3': '-3deg',
    '-2': '-2deg',
    '-1': '-1deg',
  },
  saturate: { '0': '0', '50': '.5', '100': '1', '150': '1.5', '200': '2' },
  scale: {
    '0': '0',
    '50': '.5',
    '75': '.75',
    '90': '.9',
    '95': '.95',
    '100': '1',
    '105': '1.05',
    '110': '1.1',
    '125': '1.25',
    '150': '1.5',
  },
  sepia: { '0': '0', 'DEFAULT': '100%' },
  skew: {
    '0': '0deg',
    '1': '1deg',
    '2': '2deg',
    '3': '3deg',
    '6': '6deg',
    '12': '12deg',
    '-12': '-12deg',
    '-6': '-6deg',
    '-3': '-3deg',
    '-2': '-2deg',
    '-1': '-1deg',
  },
  space: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-20': '-5rem',
    '-22': '-5.5rem',
    '-24': '-6rem',
    '-25': '-6.25rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-34': '-8.5rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-144': '-36rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '-7/10': '-70%',
    '-55/100': '-55%',
    '-1/2': '-50%',
    '-45/100': '-45%',
    '-2/5': '-40%',
    '-3/10': '-30%',
    '--18': '4.5rem',
    '--16': '4rem',
    '--2px': '2px',
    '-3px': '-3px',
    '-4px': '-4px',
    '-6px': '-6px',
    '-8px': '-8px',
    '-18px': '-18px',
  },
  stroke: { current: 'currentColor' },
  strokeWidth: { '0': '0', '1': '1', '2': '2' },
  textColor: {
    'purple': '#6b1F99',
    'dark-purple': '#35196C',
    'light-purple': '#E8C2FF',
    'lighter-purple': '#F2EBF6',
    'white': '#FFFFFF',
    'dark-white': '#FEFEFE',
    'lighter-gray': '#F2F2F2',
    'light-gray': '#757677',
    'medium-gray': '#434B5A',
    'dark-gray': '#232323',
    'red': '#D31229',
    'green': '#06A86E',
    'light-outline-purple': '#6D5995',
    'light-outline-gray': '#D8D8D8',
    'outline-gray': '#A4A7AB',
    'orange': '#FF4500',
    'red-orange': '#DC1300',
    'light-blue': '#00A6FF',
    'medium-blue': '#007BE7',
    'light-beige': '#F8DBB1',
    'beige': '#F8C592',
    'yellow': '#FFF171',
    'ui-yellow': '#E79D0C',
    'transparent': 'transparent',
    'black': '#000',
  },
  textOpacity: {
    '0': '0',
    '5': '0.05',
    '10': '0.1',
    '20': '0.2',
    '25': '0.25',
    '30': '0.3',
    '40': '0.4',
    '50': '0.5',
    '60': '0.6',
    '70': '0.7',
    '75': '0.75',
    '80': '0.8',
    '90': '0.9',
    '95': '0.95',
    '100': '1',
  },
  transformOrigin: {
    'center': 'center',
    'top': 'top',
    'top-right': 'top right',
    'right': 'right',
    'bottom-right': 'bottom right',
    'bottom': 'bottom',
    'bottom-left': 'bottom left',
    'left': 'left',
    'top-left': 'top left',
  },
  transitionDelay: {
    '75': '75ms',
    '100': '100ms',
    '150': '150ms',
    '200': '200ms',
    '300': '300ms',
    '500': '500ms',
    '700': '700ms',
    '1000': '1000ms',
  },
  transitionDuration: {
    '75': '75ms',
    '100': '100ms',
    '150': '150ms',
    '200': '200ms',
    '300': '300ms',
    '500': '500ms',
    '700': '700ms',
    '1000': '1000ms',
    'DEFAULT': '150ms',
  },
  transitionProperty: {
    none: 'none',
    all: 'all',
    DEFAULT:
      'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
    colors: 'background-color, border-color, color, fill, stroke',
    opacity: 'opacity',
    shadow: 'box-shadow',
    transform: 'transform',
    height: 'height',
  },
  transitionTimingFunction: {
    'DEFAULT': 'cubic-bezier(0.4, 0, 0.2, 1)',
    'linear': 'linear',
    'in': 'cubic-bezier(0.4, 0, 1, 1)',
    'out': 'cubic-bezier(0, 0, 0.2, 1)',
    'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  translate: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-20': '-5rem',
    '-22': '-5.5rem',
    '-24': '-6rem',
    '-25': '-6.25rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-34': '-8.5rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-144': '-36rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '-7/10': '-70%',
    '-55/100': '-55%',
    '-1/2': '-50%',
    '-45/100': '-45%',
    '-2/5': '-40%',
    '-3/10': '-30%',
    '--18': '4.5rem',
    '--16': '4rem',
    '--2px': '2px',
    '-3px': '-3px',
    '-4px': '-4px',
    '-6px': '-6px',
    '-8px': '-8px',
    '-18px': '-18px',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    'full': '100%',
    '-1/3': '-33.333333%',
    '-2/3': '-66.666667%',
    '-1/4': '-25%',
    '-2/4': '-50%',
    '-3/4': '-75%',
    '-full': '-100%',
  },
  width: {
    '0': '0px',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '14': '3.5rem',
    '16': '4rem',
    '18': '4.5rem',
    '20': '5rem',
    '22': '5.5rem',
    '24': '6rem',
    '25': '6.25rem',
    '28': '7rem',
    '32': '8rem',
    '34': '8.5rem',
    '36': '9rem',
    '40': '10rem',
    '44': '11rem',
    '48': '12rem',
    '52': '13rem',
    '56': '14rem',
    '60': '15rem',
    '64': '16rem',
    '72': '18rem',
    '80': '20rem',
    '96': '24rem',
    '144': '36rem',
    'auto': 'auto',
    'px': '1px',
    '0.5': '0.125rem',
    '1.5': '0.375rem',
    '2.5': '0.625rem',
    '3.5': '0.875rem',
    '7/10': '70%',
    '55/100': '55%',
    '1/2': '50%',
    '45/100': '45%',
    '2/5': '40%',
    '3/10': '30%',
    '-18': '-4.5rem',
    '-16': '-4rem',
    '-2px': '-2px',
    '2px': '2px',
    '3px': '3px',
    '4px': '4px',
    '6px': '6px',
    '8px': '8px',
    '18px': '18px',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    '1/12': '8.333333%',
    '2/12': '16.666667%',
    '3/12': '25%',
    '4/12': '33.333333%',
    '5/12': '41.666667%',
    '6/12': '50%',
    '7/12': '58.333333%',
    '8/12': '66.666667%',
    '9/12': '75%',
    '10/12': '83.333333%',
    '11/12': '91.666667%',
    'full': '100%',
    'screen': '100vw',
    'min': 'min-content',
    'max': 'max-content',
    'search-screen-lg': '40rem',
  },
  zIndex: {
    '0': '0',
    '10': '10',
    '20': '20',
    '30': '30',
    '40': '40',
    '50': '50',
    '200': '200',
    'auto': 'auto',
    '-10': '-10',
    'force-second': '9998',
    'force-top': '9999',
  },
};
